<template>
  <div class="organization-details-wrap">
    <v-btn text @click="$router.go(-1)" style="margin-left: -16px;">
        <v-icon left>mdi-chevron-left</v-icon>
        Back
    </v-btn>
    <div class="mb-7 mt-3 d-flex flex-wrap">
        <h2 class="headline">Company Profiles</h2>
        <v-spacer></v-spacer>
      <v-btn 
        v-if="!loading"
        @click="$root.$emit('EditOrganization', {...organizationData, active})"
        color="success"
        :disabled="(active === 1 && !permissions.includes('product_guide')) || (active === 2 && !permissions.includes('trainings'))"
      >
        <v-icon left>mdi-pencil</v-icon>
        Edit info
      </v-btn>
      <template v-else>
        <v-skeleton-loader
          type="button"
          class="mx-auto mb-4"
        ></v-skeleton-loader>
      </template>
    </div>

    <v-card v-if="!loading" class="my-4 elevation-3">
      <div>
        <v-tabs
          v-model="active"
          color="primary"
          slider-color="primary"
        >
          <v-tab
            ripple
          >
            General
          </v-tab>
          <v-tab
            ripple
          >
            Product Guide
          </v-tab>
          <v-tab
            ripple
          >
            Training Guide
          </v-tab>

          <!-- General -->
          <v-tab-item>
            <v-divider></v-divider>
            <v-simple-table v-if="!no_data.includes(organization)" :loading="loading">
              <template>
                <tbody>
                  <tr>
                    <td>Name</td>
                    <td>
                      <span v-if="!no_data.includes(organization.name)">{{ organization.name }}</span>
                      <em v-else class="grey--text">No data</em>
                    </td>
                  </tr>
                  <tr>
                    <td>Contact First Name</td>
                    <td>
                      <span v-if="!no_data.includes(organization.user) && !no_data.includes(organization.user.first_name)">{{ organization.user.first_name }}</span>
                      <em v-else class="grey--text">No data</em>
                    </td>
                  </tr>
                  <tr>
                    <td>Contact Last Name</td>
                    <td>
                      <span v-if="!no_data.includes(organization.user) && !no_data.includes(organization.user.last_name)">{{ organization.user.last_name }}</span>
                      <em v-else class="grey--text">No data</em>
                    </td>
                  </tr>
                  <tr>
                    <td>Facebook</td>
                    <td>
                      <span v-if="!no_data.includes(organization.facebook)">{{ organization.facebook }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>Twitter</td>
                    <td>
                      <span v-if="!no_data.includes(organization.twitter)">{{ organization.twitter }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>Pinterest</td>
                    <td>
                      <span v-if="!no_data.includes(organization.pinterest)">{{ organization.pinterest }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>Youtube</td>
                    <td>
                      <span v-if="!no_data.includes(organization.youtube)">{{ organization.youtube }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>Instagram</td>
                    <td>
                      <span v-if="!no_data.includes(organization.instagram)">{{ organization.instagram }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>Linkedin</td>
                    <td>
                      <span v-if="!no_data.includes(organization.linkedin)">{{ organization.linkedin }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-divider></v-divider>
            <div class="px-4 pb-5">
              <div v-if="!loading">
                <div class="mb-2 mt-7 d-flex flex-wrap">
                  <h2 class="title">Type of Projects</h2>
                </div>
                <template v-if="!no_data.includes(organization_projects) && organization_projects.length > 0">
                  <v-chip
                    v-for="item in organization_projects"
                    :key="item.id"
                    class="my-1 mr-2"
                    color="primary"
                    outlined
                  >
                    {{ decodeHTMLEntities(item.name) }}
                  </v-chip>
                </template>
                <div v-else class="body-2 mb-3 grey--text">
                  There are no selected type of projects.
                </div>
              </div>

              <div v-if="!loading" class="mb-5">
                <div class="mb-2 mt-7 d-flex flex-wrap">
                  <h2 class="title">Post Topics</h2>
                </div>
                <template v-if="!no_data.includes(organization_topics) && organization_topics.length > 0">
                  <v-chip
                    v-for="item in organization_topics"
                    :key="item.id"
                    class="my-1 mr-2"
                    color="primary"
                    outlined
                  >
                    {{ decodeHTMLEntities(item.name) }}
                  </v-chip>
                </template>
                <div v-else class="body-2 mb-3 grey--text">
                  There are no selected post topics.
                </div>
              </div>

            </div>
          </v-tab-item>

          <!-- Product Guide -->
          <v-tab-item>
            <v-divider></v-divider>
            <v-simple-table v-if="!no_data.includes(organization)" :loading="loading">
              <template v-if="permissions.includes('product_guide')">
                <tbody>
                  <tr>
                    <td>Logo</td>
                    <td>
                      <v-img v-if="!no_data.includes(organization.photo)"
                        :src="organization.photo"
                        :lazy-src="organization.photo"
                        max-width="200"
                        max-height="70"
                        class="my-2 pointer"
                        @click="$root.$emit('openImage', organization.photo)"
                      ></v-img>
                      <em v-else class="grey--text">No data</em>
                    </td>
                  </tr>
                  <tr>
                    <td>Description</td>
                    <td>
                      <span v-if="!no_data.includes(organization.description)">{{ organization.description }}</span>
                      <em v-else class="grey--text">No data</em>
                    </td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>
                      <span v-if="!no_data.includes(organization.company_email)">{{ organization.company_email }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>
                      <span v-if="!no_data.includes(organization.company_phone)">{{ organization.company_phone }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>
                      <span v-if="!no_data.includes(organization.address)">{{ organization.address }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>
                      <span v-if="!no_data.includes(organization.city)">{{ organization.city }}</span>
                      <em v-else class="grey--text">No data</em>
                    </td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>
                      <span v-if="!no_data.includes(organization.state)">{{ organization.state }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>Website</td>
                    <td>
                      <span v-if="!no_data.includes(organization.website)">{{ organization.website }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                </tbody>
              </template>
              <template v-else>
                <tbody>
                  <tr>
                    <td colspan="2">
                      <div class="body-2 py-5">
                        You do not have access to the Product Guide. Please email us at <a href="mailto:info@concretedecor.net">info@concretedecor.net</a> for more information about how you can be included.
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-divider></v-divider>

            <div class="px-4 pb-5">
              <div v-if="!loading">
                <div class="mb-2 mt-7 d-flex flex-wrap">
                  <h2 class="title">Product Guide Categories</h2>
                </div>
                <template v-if="!no_data.includes(organization_products) && organization_products.length > 0">
                  <v-chip
                    v-for="item in organization_products"
                    :key="item.id"
                    class="my-1 mr-2"
                    color="primary"
                    outlined
                  >
                    {{ decodeHTMLEntities(item.name) }}
                  </v-chip>
                </template>
                <div v-else class="body-2 mb-3 grey--text">
                  There are no selected produc guide categories.
                </div>
              </div>
            </div>
          </v-tab-item>

          <!-- Training Guide -->
          <v-tab-item>
            <v-divider></v-divider>
            <v-simple-table v-if="!no_data.includes(organization)" :loading="loading">
              <template v-if="permissions.includes('trainings')">
                <tbody>
                  <tr>
                    <td colspan="2">
                      <v-layout>
                        <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
                        <v-btn 
                          @click="$router.push('/trainings')"
                          class="my-2"
                          small
                          color="success"
                          :block="$vuetify.breakpoint.xs"
                        >View Trainings</v-btn>
                      </v-layout>
                    </td>
                  </tr>
                  <tr>
                    <td>Name</td>
                    <td>
                      <span v-if="!no_data.includes(organization.trainings_name)">{{ organization.trainings_name }}</span>
                      <em v-else class="grey--text">No data</em>
                    </td>
                  </tr>
                  <tr>
                    <td>Logo</td>
                    <td>
                      <v-img v-if="!no_data.includes(organization.trainings_photo)"
                        :src="organization.trainings_photo"
                        :lazy-src="organization.trainings_photo"
                        max-width="200"
                        max-height="70"
                        class="my-2 pointer"
                        @click="$root.$emit('openImage', organization.trainings_photo)"
                      ></v-img>
                      <em v-else class="grey--text">No data</em>
                    </td>
                  </tr>
                  <tr>
                    <td>Description</td>
                    <td>
                      <span v-if="!no_data.includes(organization.trainings_description)">{{ organization.trainings_description }}</span>
                      <em v-else class="grey--text">No data</em>
                    </td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>
                      <span v-if="!no_data.includes(organization.trainings_email)">{{ organization.trainings_email }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>
                      <span v-if="!no_data.includes(organization.trainings_phone)">{{ organization.trainings_phone }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>
                      <span v-if="!no_data.includes(organization.trainings_address)">{{ organization.trainings_address }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>
                      <span v-if="!no_data.includes(organization.trainings_city)">{{ organization.trainings_city }}</span>
                      <em v-else class="grey--text">No data</em>
                    </td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>
                      <span v-if="!no_data.includes(organization.trainings_state)">{{ organization.trainings_state }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                  <tr>
                    <td>Website</td>
                    <td>
                      <span v-if="!no_data.includes(organization.trainings_website)">{{ organization.trainings_website }}</span>
                      <em v-else class="grey--text">No data</em>  
                    </td>
                  </tr>
                </tbody>
              </template>
              <template v-else>
                <tbody>
                  <tr>
                    <td colspan="2">
                      <div class="body-2 py-5">
                        You do not publish events in the training guide. Please email us at <a href="mailto:info@concretedecor.net">info@concretedecor.net</a> for more information about how to start advertising your events.
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-divider></v-divider>

            <div class="px-4 pb-5">
              <div v-if="!loading">
                <div class="mb-2 mt-7 d-flex flex-wrap">
                  <h2 class="title">Training Guide Categories</h2>
                </div>
                <template v-if="!no_data.includes(organization_trainings) && organization_trainings.length > 0">
                  <v-chip
                    v-for="item in organization_trainings"
                    :key="item.id"
                    class="my-1 mr-2"
                    color="primary"
                    outlined
                  >
                    {{ decodeHTMLEntities(item.name) }}
                  </v-chip>
                </template>
                <div v-else class="body-2 mb-3 grey--text">
                  There are no selected training guide categories.
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-card>

    <template v-else>
      <v-skeleton-loader
        type="paragraph"
        class="mx-auto mb-4"
      ></v-skeleton-loader>
      <v-skeleton-loader
        type="paragraph"
        class="mx-auto"
      ></v-skeleton-loader>
    </template>
    
    <company-edit @done="initialize"></company-edit>
  </div>
</template>

<script>
import ApiService from "@/common/api.service"
import {getOrganizationId} from "@/common/jwt.service"
import {mapGetters, mapState} from "vuex"
import CompanyEdit from "./CompanyEdit"

export default {
  name: 'OrganizationDetails',
  components: {
    CompanyEdit
  },
  data: () => ({
    active: null,
    no_data: [null, "", undefined, "null"],
    organization: null,
    organization_products: null,
    organization_projects: null,
    organization_topics: null,
    organization_trainings: null,
    states: null,
    loading: false,
    organizationData: {},
  }),
  mounted() {
    if(this.active_tab) { this.active = this.active_tab }
    this.initialize()
  },
  updated() {
    this.$store.state.active_profile_tab = null;
  },
  methods: {
    initialize() {
      this.loading = true;
      ApiService.get(`/organization/${getOrganizationId()}/show`)
        .then(response => {
          this.organization = response.data.organization
          this.organization_products = response.data.organization_products
          this.organization_projects = response.data.organization_projects
          this.organization_topics = response.data.organization_topics
          this.organization_trainings = response.data.organization_trainings
          this.organizationData = {
            organization:this.organization,
            organization_products:this.organization_products,
            organization_projects:this.organization_projects,
            organization_topics: this.organization_topics,
            organization_trainings: this.organization_trainings
          }
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error.message);
        });
    },
    titleCase(str){
      return _.startCase(str.replace(/_/g, ' '))
    },
    decodeHTMLEntities(i) {
      return _.unescape(i)
    }
  },
  computed: {
    ...mapGetters(["user", "permissions"]),
    ...mapState({
      active_tab: state => state.active_profile_tab
    })
  }
}
</script>
